import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  SimpleGrid,
  Icon,
  Spacer,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  Text,
  Table,
  Tbody,
  Th,
  Thead,
  Tr,
  VStack,
  HStack,
  Badge,
  Stack,
  Avatar,
  Image,
  FormLabel,
  Select,
  useToast,
} from "@chakra-ui/react";

// Images
import bgProfile from "assets/img/news.jpg";
import locationMap from "assets/img/map.png";

// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import GradientBorder from "components/GradientBorder/GradientBorder";
import IconBox from "components/Icons/IconBox";
import InvoicesRow from "components/Tables/InvoicesRow";
import LineChart from "components/Charts/LineChart";

import DashboardTableRow from "components/Tables/DashboardTableRow";
// Icons
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";

import { RiMastercardFill } from "react-icons/ri";
import { useParams } from "react-router-dom";

import {
  CartIcon,
  DocumentIcon,
  GlobeIcon,
  WalletIcon,
} from "components/Icons/Icons.js";

// Data
import { invoicesData, dashboardTableData } from "variables/general";

import {
  lineChartDataDashboard,
  lineChartOptionsDashboard,
} from "variables/charts";

import DonutChart from "components/Charts/DonutChart";
import { donutChartDataDashboard } from "variables/charts";
import { donutChartOptionsDashboard } from "variables/charts";
import CustomDateInput from "components/CustomField/CustomDateInput";
import ChakraStyledSelect from "components/CustomField/ChakraStyledSelect";
import { char, position } from "stylis";
import { useLoader } from "components/Loader/loader";
import useApiReq from "variables/apireq";
import { PagingControls } from "components/ui/pagination";
import TablesTableRow from "components/Tables/TablesTableRow";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import ReactCustomMap from "components/Map/map";
import { BsFillEyeFill } from "react-icons/bs";

function Report() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemcount, setItemCount] = useState(10);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(itemcount);
  const titleColor = "white";
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [data, setData] = useState(null);
  const { setIsLoading, isLoading } = useLoader();
  const [error, setError] = useState(null);
  const [campaigns, setCampaigns] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectCampaingList, setSelectCampaingList] = useState(null);
  const [seletcCampaignGroup, setSelectCampaignGroup] = useState(null);
  const [selectedbanner, setSelectedBanner] = useState([]);
  const [selectedContent, setSelectedContent] = useState(null);
  const [chartValue, setChartValue] = useState([]);
  const [chartLabel, setChartLabels] = useState([]);
  const [groups, setGroups] = useState(null);
  const toast = useToast({ position: "top" });
  useEffect(() => {
    setStart((currentPage - 1) * itemcount);
    setEnd(currentPage * itemcount);
  }, [currentPage, itemcount]);

  const fetchCampaignGroup = async () => {
    setIsLoading(true);
    try {
      const res = await useApiReq({
        url: "group/",
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.response) {
        setGroups(
          res.response.map((item) => {
            return { label: item?.group_name, value: item?.uuid };
          })
        );
      }
    } catch (e) {
      setError(e);
    }
  };

  useEffect(() => {
    if (error) {
      toast({
        title: "Error",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      const chartValue = [
        {
          name: "Readers",
          data: data?.table?.map((item) => item.readers),
        },
      ];
      setChartValue(chartValue ?? []);
      const chartLabels = data?.table?.map((item) => item.date);

      setChartLabels(chartLabels ?? []);
    }
  }, [data]);

  const fetchReport = async (data) => {
    setError(null);
    setIsLoading(true);
    try {
      const res = await useApiReq({
        url: `report/`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: data,
      });
      if (res.response) {
        setData(res.response);
        setError(null);
        setSelectedContent(
          res.response?.campaing_info?.content || "No content found"
        );
        if (res.response?.campaing_info?.banner) {
          setSelectedBanner(JSON.parse(res.response?.campaing_info?.banner));
        } else {
          setSelectedBanner([]);
        }
      }
    } catch (e) {
      setError(e);
    } finally {
      if (campaigns.length === 0) {
        await fetchCampaings();
      }
      setIsLoading(false);
    }
  };

  const fetchCampaings = async () => {
    setIsLoading(true);
    try {
      const res = await useApiReq({
        url: `campaign/`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.response) {
        setCampaigns(res.response);
        if (searchParams.get("uuid")) {
          setSelectedCampaign({
            label: res.response.find(
              (campaign) => campaign.uuid === searchParams.get("uuid")
            )?.name,
            value: searchParams.get("uuid"),
          });
        }
      }
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const data = {};
    if (startDate) {
      data.start_date = startDate;
      data.end_date = endDate ?? new Date();
    }
    if (selectedCampaign && selectedCampaign?.value !== null) {
      data.campaign_uuid = selectedCampaign.value;
    }
    if (endDate) {
      data.end_date = endDate;
    }
    if (seletcCampaignGroup && seletcCampaignGroup?.value !== null) {
      data.group_uuid = seletcCampaignGroup.value;
    }
    if (Object.keys(data).length > 0) {
      fetchReport(data);
    }
  }, [startDate, endDate, selectedCampaign, seletcCampaignGroup]);
  useEffect(() => {
    if (campaigns === null) {
      fetchCampaings();
    }
    if (groups === null) {
      fetchCampaignGroup();
    }
  }, []);

  const text = (child) => {
    return (
      <Text fontSize="sm" color="#fff" fontWeight="normal">
        {child}
      </Text>
    );
  };

  const handleContentClick = (value) => {
    const mimeMatch = value.match(/^data:(.*?);base64,/);
    if (!mimeMatch) return;

    const mimeType = mimeMatch[1];

    // Expanded MIME to extension mapping
    const mimeToExt = {
      "application/pdf": "pdf",
      "application/msword": "doc",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        "docx",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        "xlsx",
      "text/plain": "txt",
      "application/vnd.ms-excel": "xls",
      "application/vnd.ms-powerpoint": "ppt",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        "pptx",
    };

    const fileExt = mimeToExt[mimeType] || "file"; // default fallback
    const base64Data = value.split(",")[1];

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill()
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], {
      type: mimeType,
    });
    const fileURL = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = fileURL;
    a.download = `content.${fileExt}`;
    a.click();
  };

  const getOptimalData = (row, index) => {
    const data = {};
    data["Date"] = text(new Date(row.date).toLocaleDateString());
    data["Readers"] = text(row.readers);
    data["Unique Readers"] = text(row.unique_readers);
    data["Total Reading Time"] = text(row.total_time);
    data["Avg Reading Time"] = text(row.average_time);

    return data;
  };
  const getHeaders = () => {
    return [
      "Date",
      "Readers",
      "Unique Readers",
      "Total Reading Time",
      "Avg Reading Time",
    ];
  };

  useEffect(() => {
    if (campaigns !== null) {
      setSelectCampaingList(
        campaigns.map((campaign) => {
          return { label: campaign?.name, value: campaign?.uuid };
        })
      );
    }
  }, [campaigns]);

  if (isLoading) {
    return <div></div>;
  }
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }} mx="auto">
      <Grid templateColumns={{ sm: "1fr", lg: "64% 34%" }}>
        <Box>
          <Grid
            templateColumns={{
              sm: "1fr",
              lg: "1fr 1.7fr",
            }}
            gap="20px"
          >
            {/* Campaign Card */}
            <Card
              bg="linear-gradient(130deg, #8D8D8D18 0%, #FFFFFF36 100%)"
              filter="drop-shadow(0px 4px 25px rgba(0, 0, 0, 0.1))"
              maxW={{ sm: "100%", lg: "100%" }}
              w={{ sm: "100%", lg: "100%" }}
              //   h={{ sm: "270px", lg: "350px", xl: "410px" }}
              gridArea={{ xl: "1 / 1 / 2 / 2", "2xl": "auto" }}
            >
              <Flex
                direction="column"
                align="center"
                h="100%"
                w="100%"
                p="20px"
                hidden={data?.campaing_info === undefined}
              >
                <Text color="#fff" fontSize="30px" fontWeight="bold" mb="8px">
                  PR CAMPAIGN
                </Text>
                <Text color="#fff" fontSize="24px" my="12px">
                  {data?.campaing_info?.name || ""}
                </Text>
                <Text color="#fff" fontSize="24px" my="12px" fontWeight="bold">
                  {data?.campaing_info?.price} BDT
                </Text>
                {/* <Badge
                  bgColor="blue.400"
                  variant="solid"
                  colorPalette="blue"
                  size="lg"
                >
                  Premium PR
                </Badge> */}
                <Stack direction="row">
                  <Badge
                    colorScheme="orange"
                    h={"24px"}
                    w={"auto"}
                    paddingTop={"3px"}
                  >
                    {data?.campaing_info?.type}
                  </Badge>
                </Stack>
                {/* <Button
                  alignSelf="flex-start"
                  variant="no-hover"
                  bg="transparent"
                  p="0px"
                >
                  <Text
                    fontSize="xs"
                    color="#fff"
                    me="5px"
                    cursor="pointer"
                    transition="all .3s ease"
                    _hover={{ me: "6px" }}
                  >
                    Tab to record
                  </Text>
                  <Icon
                    as={BsArrowRight}
                    w="13px"
                    h="13px"
                    color="#fff"
                    transition="all .3s ease"
                    cursor="pointer"
                    _hover={{ transform: "translateX(20%)" }}
                  />
                </Button> */}
              </Flex>
            </Card>
            <SimpleGrid columns={{ sm: 1, md: 2, xl: 2 }} spacing="24px">
              {/* Avg Reading Card */}
              <Card
                border="1px solid"
                borderColor="rgba(255, 255, 255, 0.15)"
                filter="blur(0px)"
                boxShadow="0px 7px 23px rgba(0, 0, 0, 0.05)"
                bg="linear-gradient(126.97deg, #060C29 28.26%, rgba(4, 12, 48, 0.5) 91.2%)"
                borderRadius="20px"
              >
                <CardBody>
                  <Flex
                    flexDirection="row"
                    align="center"
                    justify="center"
                    w="100%"
                  >
                    <Stat me="auto">
                      <StatLabel
                        fontSize="sm"
                        color="gray.400"
                        fontWeight="bold"
                        pb="2px"
                      >
                        Number of Readers
                      </StatLabel>
                      <Flex>
                        <StatNumber
                          fontSize="lg"
                          color="#fff"
                          fontWeight="bold"
                        >
                          {data?.other?.total_readers || 0}
                        </StatNumber>
                        <StatHelpText
                          alignSelf="flex-end"
                          justifySelf="flex-end"
                          m="0px"
                          color="green.400"
                          fontWeight="bold"
                          ps="3px"
                          fontSize="md"
                        ></StatHelpText>
                      </Flex>
                    </Stat>
                    <IconBox as="box" h={"45px"} w={"45px"} bg="brand.200">
                      <CartIcon h={"24px"} w={"24px"} color="#fff" />
                    </IconBox>
                  </Flex>
                </CardBody>
              </Card>
              <Card
                border="1px solid"
                borderColor="rgba(255, 255, 255, 0.15)"
                filter="blur(0px)"
                boxShadow="0px 7px 23px rgba(0, 0, 0, 0.05)"
                bg="linear-gradient(126.97deg, #060C29 28.26%, rgba(4, 12, 48, 0.5) 91.2%)"
                borderRadius="20px"
              >
                <CardBody>
                  <Flex
                    flexDirection="row"
                    align="center"
                    justify="center"
                    w="100%"
                  >
                    <Stat me="auto">
                      <StatLabel
                        fontSize="sm"
                        color="gray.400"
                        fontWeight="bold"
                        pb="2px"
                      >
                        Total Reading Time
                      </StatLabel>
                      <Flex>
                        <StatNumber
                          fontSize="lg"
                          color="#fff"
                          fontWeight="bold"
                        >
                          {(
                            (data?.other?.total_reading_time || 0) / 60
                          ).toFixed(2)}{" "}
                          min
                        </StatNumber>
                        <StatHelpText
                          alignSelf="flex-end"
                          justifySelf="flex-end"
                          m="0px"
                          color="green.400"
                          fontWeight="bold"
                          ps="3px"
                          fontSize="md"
                        ></StatHelpText>
                      </Flex>
                    </Stat>
                    <IconBox as="box" h={"45px"} w={"45px"} bg="brand.200">
                      <CartIcon h={"24px"} w={"24px"} color="#fff" />
                    </IconBox>
                  </Flex>
                </CardBody>
              </Card>
              <Card
                border="1px solid"
                borderColor="rgba(255, 255, 255, 0.15)"
                filter="blur(0px)"
                boxShadow="0px 7px 23px rgba(0, 0, 0, 0.05)"
                bg="linear-gradient(126.97deg, #060C29 28.26%, rgba(4, 12, 48, 0.5) 91.2%)"
                borderRadius="20px"
              >
                <CardBody>
                  <Flex
                    flexDirection="row"
                    align="center"
                    justify="center"
                    w="100%"
                  >
                    <Stat me="auto">
                      <StatLabel
                        fontSize="sm"
                        color="gray.400"
                        fontWeight="bold"
                        pb="2px"
                      >
                        Avg Reading Time
                      </StatLabel>
                      <Flex>
                        <StatNumber fontSize="lg" color="#fff">
                          {((data?.other?.avg_reading_time || 0) / 60).toFixed(
                            2
                          )}{" "}
                          min
                        </StatNumber>
                        <StatHelpText
                          alignSelf="flex-end"
                          justifySelf="flex-end"
                          m="0px"
                          color="green.400"
                          fontWeight="bold"
                          ps="3px"
                          fontSize="md"
                        ></StatHelpText>
                      </Flex>
                    </Stat>
                    <IconBox as="box" h={"45px"} w={"45px"} bg="brand.200">
                      <WalletIcon h={"24px"} w={"24px"} color="#fff" />
                    </IconBox>
                  </Flex>
                </CardBody>
              </Card>
              {/* Unique Reach Card */}
              <Card
                border="1px solid"
                borderColor="rgba(255, 255, 255, 0.15)"
                filter="blur(0px)"
                boxShadow="0px 7px 23px rgba(0, 0, 0, 0.05)"
                bg="linear-gradient(126.97deg, #060C29 28.26%, rgba(4, 12, 48, 0.5) 91.2%)"
                borderRadius="20px"
              >
                <CardBody>
                  <Flex
                    flexDirection="row"
                    align="center"
                    justify="center"
                    w="100%"
                  >
                    <Stat me="auto">
                      <StatLabel
                        fontSize="sm"
                        color="gray.400"
                        fontWeight="bold"
                        pb="2px"
                      >
                        Unique Reach
                      </StatLabel>
                      <Flex>
                        <StatNumber fontSize="lg" color="#fff">
                          {data?.other?.total_unique_readers || 0}
                        </StatNumber>
                        <StatHelpText
                          alignSelf="flex-end"
                          justifySelf="flex-end"
                          m="0px"
                          color="green.400"
                          fontWeight="bold"
                          ps="3px"
                          fontSize="md"
                        ></StatHelpText>
                      </Flex>
                    </Stat>
                    <IconBox as="box" h={"45px"} w={"45px"} bg="brand.200">
                      <GlobeIcon h={"24px"} w={"24px"} color="#fff" />
                    </IconBox>
                  </Flex>
                </CardBody>
              </Card>
              {/* Total Reading Time Card */}
              <Card
                border="1px solid"
                borderColor="rgba(255, 255, 255, 0.15)"
                filter="blur(0px)"
                boxShadow="0px 7px 23px rgba(0, 0, 0, 0.05)"
                bg="linear-gradient(126.97deg, #060C29 28.26%, rgba(4, 12, 48, 0.5) 91.2%)"
                borderRadius="20px"
              >
                <CardBody>
                  <Flex
                    flexDirection="row"
                    align="center"
                    justify="center"
                    w="100%"
                  >
                    <Stat>
                      <StatLabel
                        fontSize=".9em"
                        color="gray.400"
                        fontWeight="bold"
                        w="8rem"
                        pb="2px"
                        whiteSpace="nowrap"
                      >
                        <sup>Organic reader</sup> VS <sub>Push Reader</sub>
                      </StatLabel>
                      <Flex>
                        <StatNumber fontSize="lg" color="#fff">
                          {(
                            ((data?.other?.total_unique_readers || 0) /
                              (data?.other?.total_readers || 0)) *
                              100 || 0
                          ).toFixed(2)}
                          %
                        </StatNumber>
                        <StatHelpText
                          alignSelf="flex-end"
                          justifySelf="flex-end"
                          m="0px"
                          color="red.500"
                          fontWeight="bold"
                          ps="3px"
                          fontSize="md"
                        ></StatHelpText>
                      </Flex>
                    </Stat>
                    <Spacer />
                    <IconBox as="box" h={"45px"} w={"45px"} bg="brand.200">
                      <DocumentIcon h={"24px"} w={"24px"} color="#fff" />
                    </IconBox>
                  </Flex>
                </CardBody>
              </Card>
              {/* Readers Card */}

              <Card
                border="1px solid"
                borderColor="rgba(255, 255, 255, 0.15)"
                filter="blur(0px)"
                boxShadow="0px 7px 23px rgba(0, 0, 0, 0.05)"
                bg="linear-gradient(126.97deg, #060C29 28.26%, rgba(4, 12, 48, 0.5) 91.2%)"
                borderRadius="20px"
              >
                <CardBody>
                  <Flex
                    flexDirection="row"
                    align="center"
                    justify="center"
                    w="100%"
                  >
                    <Stat me="auto">
                      <StatLabel
                        fontSize="sm"
                        color="gray.400"
                        fontWeight="bold"
                        whiteSpace="nowrap"
                        pb="2px"
                      >
                        Readers (100+ sec)
                      </StatLabel>
                      <Flex>
                        <StatNumber
                          fontSize="lg"
                          color="#fff"
                          fontWeight="bold"
                        >
                          {data?.other?.total_readers_100_sec || 0}
                        </StatNumber>
                        <StatHelpText
                          alignSelf="flex-end"
                          justifySelf="flex-end"
                          m="0px"
                          color="green.400"
                          fontWeight="bold"
                          ps="3px"
                          fontSize="md"
                        ></StatHelpText>
                      </Flex>
                    </Stat>
                    <IconBox as="box" h={"45px"} w={"45px"} bg="brand.200">
                      <CartIcon h={"24px"} w={"24px"} color="#fff" />
                    </IconBox>
                  </Flex>
                </CardBody>
              </Card>
            </SimpleGrid>
          </Grid>
          <Card
            px="16px"
            pb="2px"
            mt="24px"
            style={{ position: "relative", zIndex: 10 }}
          >
            <Grid
              templateColumns={{
                sm: "1fr",
                md: "1fr 1fr",
                lg: "1fr 1fr 1fr 1fr",
              }}
              gap={4}
              minW={{ sm: "100%", md: "100%" }}
              w="100%"
            >
              <Flex direction="column" w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms="4px"
                  fontSize="sm"
                  fontWeight="normal"
                >
                  Start Date
                </FormLabel>
                <GradientBorder
                  mb="24px"
                  h="50px"
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius="20px"
                >
                  <CustomDateInput
                    selectedDate={startDate}
                    setSelectedDate={setStartDate}
                  />
                </GradientBorder>
              </Flex>
              <Flex direction="column" w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms="4px"
                  fontSize="sm"
                  fontWeight="normal"
                >
                  End Date
                </FormLabel>
                <GradientBorder
                  mb="24px"
                  h="50px"
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius="20px"
                >
                  <CustomDateInput
                    selectedDate={endDate}
                    setSelectedDate={setEndDate}
                  />
                </GradientBorder>
              </Flex>
              <Flex direction="column" w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms="4px"
                  fontSize="sm"
                  fontWeight="normal"
                >
                  Campaign Group
                </FormLabel>
                <GradientBorder
                  mb="24px"
                  h="50px"
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius="20px"
                >
                  <ChakraStyledSelect
                    placeholder="Select a Group"
                    options={groups}
                    setSelectedValue={setSelectCampaignGroup}
                    selectedValue={seletcCampaignGroup}
                    isMulti={false}
                  />
                </GradientBorder>
              </Flex>
              <Flex direction="column" w={{ base: "100%", lg: "100%" }}>
                <FormLabel
                  color={titleColor}
                  ms="4px"
                  fontSize="sm"
                  fontWeight="normal"
                >
                  Campaign Select
                </FormLabel>
                <GradientBorder
                  mb="24px"
                  h="50px"
                  w={{ base: "100%", lg: "100%" }}
                  borderRadius="20px"
                >
                  <ChakraStyledSelect
                    placeholder="Select a campaign"
                    selectedValue={selectedCampaign}
                    options={selectCampaingList}
                    setSelectedValue={setSelectedCampaign}
                    isMulti={false}
                  />
                </GradientBorder>
              </Flex>
            </Grid>
          </Card>
          <Card p="28px 10px 10px 28px" my={{ sm: "24px", lg: "24px" }}>
            <CardHeader mb="20px" ps="22px">
              <Flex direction="column" alignSelf="flex-start">
                <Text fontSize="lg" color="#fff" fontWeight="bold" mb="6px">
                  Day wise page view
                </Text>
                <Text fontSize="md" fontWeight="medium" color="gray.400">
                  <Text as="span" color="green.400" fontWeight="bold"></Text>{" "}
                </Text>
              </Flex>
            </CardHeader>
            <Box w="100%" minH={{ sm: "300px" }}>
              <LineChart
                lineChartData={chartValue}
                lineChartLebels={chartLabel}
              />
            </Box>
          </Card>
          {/* Day wise Break down table */}
          <Card p="16px" mt="24px" overflowX={{ sm: "scroll", xl: "hidden" }}>
            <CardHeader p="12px 0px 28px 0px">
              <Flex direction="column">
                <Text fontSize="lg" color="#fff" fontWeight="bold" pb="8px">
                  Day wise break down
                </Text>
                <Flex align="center">
                  <Icon
                    as={IoCheckmarkDoneCircleSharp}
                    color="teal.300"
                    w={4}
                    h={4}
                    pe="3px"
                  />
                  <Text fontSize="sm" color="gray.400" fontWeight="normal">
                    <Text fontWeight="bold" as="span">
                      {data?.table?.length || 0}
                    </Text>{" "}
                    Day{data?.table?.length > 1 && "s"} Analysis
                  </Text>
                </Flex>
              </Flex>
            </CardHeader>
            <CardBody>
              <Table variant="simple" color="#fff">
                <Thead>
                  <Tr my=".8rem" ps="0px" color="gray.400">
                    {getHeaders().map((header) => {
                      return (
                        <Th
                          ps="0px"
                          color="gray.400"
                          fontFamily='"Oxygen",serif'
                          borderBottomColor="#56577A"
                          textAlign="center"
                        >
                          {header}
                        </Th>
                      );
                    })}
                  </Tr>
                </Thead>
                <Tbody>
                  {data?.table
                    ?.reverse()
                    .slice(start, end)
                    .map((row, index, arr) => {
                      return (
                        <TablesTableRow
                          data={getOptimalData(row, index)}
                          lastItem={index === arr?.length - 1}
                          setOpen={() => {}}
                          isOpen={false}
                          openIndex={null}
                          currentIndex={index}
                        />
                      );
                    })}
                </Tbody>
              </Table>
            </CardBody>
            {data?.table
              .slice((currentPage - 1) * itemcount, currentPage * itemcount)
              .map((x) => (
                <Box bg={"transparent"} key={x.id}>
                  {x.text}
                </Box>
              ))}

            <Flex justify="space-between" my=".5rem">
              <PagingControls
                currentPage={currentPage}
                onGoToPage={(newPageNumber) => setCurrentPage(newPageNumber)}
                pageSize={itemcount}
                totalCount={data?.table?.length || 0}
                totalCountDescription={"Dates"}
                showPageCount={false}
              />
              <Select
                w="80px"
                variant="outline"
                colorScheme="blackAlpha"
                bg="transparent"
                backgroundColor={"transparent"}
                backdropBlur={"10px"}
                textColor="white"
                borderColor="whiteAlpha.300"
                sx={{
                  option: {
                    backgroundColor: "rgb(19,21,54)",
                    color: "white",
                  },
                }}
                iconColor="white"
                onChange={(e) => {
                  setItemCount(e.target.value);
                }}
                value={itemcount}
              >
                <option value="10" selected>
                  10
                </option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </Select>
            </Flex>
          </Card>
        </Box>
        <Box>
          {/* Content List */}
          <Card
            p="22px"
            my={{ sm: "24px", lg: "0px" }}
            ms={{ sm: "0px", lg: "24px" }}
          >
            <CardHeader>
              <Flex
                justify="space-between"
                align="center"
                // mb='1rem'
                w="100%"
                mb="12px"
              >
                <Text fontSize="lg" color="#fff" fontWeight="bold">
                  Content
                </Text>
              </Flex>
            </CardHeader>
            <CardBody style={{ display: "flex", flexDirection: "column" }}>
              <Flex direction="column" w="100%">
                {/* <Flex
                  direction="column"
                  w="100%"
                  justify={"center"}
                  align="center"
                >
                  {data?.campaing_info?.banner && (
                    <Image
                      src={data?.campaing_info?.banner || null}
                      alt="bgProfile"
                      maxW={"70%"}
                      maxH={"325px"}
                      objectFit={"contain"}
                      borderRadius="10px"
                    />
                  )}
                </Flex> */}

                <Flex align="center" justifyContent="center" gap={2} mb={8}>
                  <Text
                    onClick={() => handleContentClick(selectedContent)}
                    fontSize="16px"
                    fontWeight="500"
                    style={{ cursor: "pointer" }}
                    color="#fff"
                  >
                    View File
                  </Text>
                  <BsFillEyeFill
                    onClick={() => handleContentClick(selectedContent)}
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "#fff",
                      marginLeft: "5px",
                    }}
                  />
                </Flex>

                <Spacer />

                <Text fontSize="lg" color="#fff" fontWeight="bold">
                  Banner
                </Text>

                <Flex wrap="wrap" justifyContent="center" gap={3}>
                  {selectedbanner.map((src, index) => (
                    <Box
                      w="100%"
                      h="200px"
                      key={index}
                      boxSize="100px"
                      overflow={"hidden"}
                      borderRadius="10px"
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                      position="relative"
                      mb={2}
                    >
                      <Image
                        src={src}
                        alt={`banner-${index}`}
                        w="auto"
                        h="200px"
                        boxSize="100%"
                        objectFit="contain"
                        borderRadius="10px"
                      />
                    </Box>
                  ))}
                </Flex>
              </Flex>
            </CardBody>
          </Card>
          <Card
            p="22px"
            my={{ sm: "24px", lg: "24px" }}
            ms={{ sm: "0px", lg: "24px" }}
            h="29.5%"
          >
            <Text fontSize="lg" color="#fff" fontWeight="bold" mb="6px">
              Location
            </Text>

            <Grid
              templateColumns={{ base: "1fr" }}
              h={{ base: "100%" }}
              gap={4}
            >
              <ReactCustomMap locationList={data?.lat_lng || []} />
            </Grid>
          </Card>

          {/* Day wise page view */}

          {/* Pie chart */}
          <Card
            p="28px 0px 0px 0px"
            my={{ sm: "24px", lg: "24px" }}
            ms={{ sm: "0px", lg: "24px" }}
          >
            <Flex>
              <CardHeader mb="20px" ps="22px">
                <Flex direction="column" alignSelf="flex-start">
                  <Text fontSize="lg" color="#fff" fontWeight="bold" mb="6px">
                    Gender Ratio
                  </Text>
                  <Text fontSize="md" fontWeight="medium" color="gray.400">
                    Male VS Female
                  </Text>

                  {/* Labels Section */}
                  <VStack align="flex-start" spacing="8px" mt="24px" flex="1">
                    <HStack spacing="8px" alignItems="center">
                      <Box bg="#24C9AC" w="8px" h="8px" borderRadius="full" />
                      <Text fontSize="sm" color="#c8cfca">
                        Male
                      </Text>
                    </HStack>
                    <HStack spacing="8px" alignItems="center">
                      <Box bg="#4B5563" w="8px" h="8px" borderRadius="full" />
                      <Text fontSize="sm" color="#c8cfca">
                        Female
                      </Text>
                    </HStack>
                  </VStack>
                </Flex>
              </CardHeader>
              <Box w="100%" pb="16px" minH={{ sm: "300px", md: "250px" }}>
                <DonutChart
                  donutChartData={donutChartDataDashboard}
                  donutChartOptions={donutChartOptionsDashboard}
                />
              </Box>
            </Flex>
          </Card>
        </Box>
      </Grid>
    </Flex>
  );
}

export default Report;
